import request from "_private/utils/request";

/**
 * 用户管理列表、新增可扩展字段
 * @param {*} data
 *
 * moduleId 必须传
 * edit 列表页： false， 编辑页： true
 * primaryKeyId 只有修改的时候传该字段
 *
 */
export function FetchGetExtColumn(data) {
  return request({
    url: "/base/user/getExtColumn",
    method: "post",
    data,
  });
}

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
  return request({
    url: "/base/user/findByPage",
    method: "post",
    data,
  });
}

/**
 * 新增列表
 * @param {*} data
 */
export function FetchAddUser(data) {
  return request({
    url: "/base/user/addUser",
    method: "post",
    data,
  });
}

/**
 * 修改用户信息
 * @param {*} data
 */
export function FetchUpdateUser(data) {
  return request({
    url: "/base/user/updateUser",
    method: "post",
    data,
  });
}

// 新增修改时获取角色，下拉框
export function FetchGetUserAllRole() {
  return request({
    url: "/base/user/getUserAllRole",
    method: "get",
  });
}

/**
 * 新增、修改用户信息
 * @param {*} data
 */
export function FetchSaveUser(data) {
  return request({
    url: "/base/user/saveUser",
    method: "post",
    headers: { type: "json" },
    data,
  });
}

/**
 * 修改用户时，先获取用户信息
 * @param {*} data
 */
export function FetchFindUserByPeopleId(data) {
  return request({
    url: "/base/user/findUserByPeopleId",
    method: "post",
    data,
  });
}

/**
 * 删除用户
 * @param {*} data
 */
export function FetchDeleteUser(data) {
  return request({
    url: "/base/user/deleteUser",
    method: "post",
    data,
  });
}

/**
 * 校验用户名
 * @param {*} data
 */
export function FetchCheckUserCodeIsExist(data) {
  return request({
    url: "/base/user/checkUserCodeIsExist",
    method: "post",
    data,
  });
}

/**
 * 获取企业数据
 * @param {*} data
 */
export function FetchAllComparys() {
  return request({
    url: "/base/compary/findAllComparys",
    method: "post",
  });
}

/**
 * 获取企业及区位数据
 * @param {*} data
 */
export function FetchAllComparysAndCounty() {
  return request({
    url: "/base/compary/getCompanyTree",
    method: "post",
  });
}

/**
 * 用户启用禁用
 * @param {*} data
 */
export function FetchChangeIsAbleUse(data) {
  return request({
    url: "/base/user/changeIsAbleUse",
    method: "post",
    data,
  });
}
